<script>
export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        parseBoolean: function (bool) {
          return bool && bool.toString().toLowerCase() == "true";
        }
      }
    });
  }
}
</script>
